<script>
  import { createEventDispatcher } from 'svelte'
  import { contacts, viewStack, sendToContact, friendGroups } from '../../stores'
  import ViewHeader from '../ViewHeader'
  import { contactsSort } from '../../functions/contacts-sort.js'
  import ContactSelectionItem from '../ContactSelectionItem.svelte'

  function selectGroup(group) {
    for (let i = 0; i < allContacts.length; i++) {
      const isMember = group.contactIds.includes(allContacts[i].contact.id)
      const isAccepting = allContacts[i].contact.exchangeCompletedAt != null
      allContacts[i].selected = isMember && isAccepting
    }
  }

  export let disabled

  const dispatch = createEventDispatcher()
  const allContacts = []
  let errorMessage = null

  $: selection = allContacts.filter((contact) => contact.selected)
  $: allSelected = allContacts.length > 0 && selection.length === allContacts.length

  function toggleSelectAll() {
    const targetState = !allSelected
    for (let i = 0; i < allContacts.length; i++) {
      allContacts[i].selected = targetState
    }
  }

  function setErrorMessage (event) {
    errorMessage = event.detail
  }

  async function confirm () {
    const selectedContacts = selection.map((contact) => contact.contact)

    dispatch('confirm', { selectedContacts })
  }

  function setup () {
    const sortedContacts = $contacts.sort(contactsSort)

    for (const contact of sortedContacts) {
      let selected = false

      if ($sendToContact != null && $sendToContact.id === contact.id) {
        selected = true
      }

      allContacts.push({ selected, contact })
    }
  }

  setup()
</script>

<ViewHeader popWhenClose={false} on:close={() => dispatch('cancel')}>
  Send to...
</ViewHeader>

{#if allContacts.length === 0}
  <p>
    There is no one to send your pic to.
    Go to the <button class="-button-link" on:click={() => viewStack.push('Inbox')}>inbox</button> and invite friends.
  </p>
{/if}

{#if errorMessage}
  <p>{errorMessage}</p>
{/if}

<div class="list">
  {#if allContacts.length > 1}
    <div class="selection-header">
      <label class="select-all">
        <input type="checkbox" checked={allSelected} on:change={toggleSelectAll} />
        <span>Select All</span>
      </label>

      {#if $friendGroups.length > 0}
        <div class="friend-groups-shortcuts">
          {#each $friendGroups as group}
            <button 
              class="group-shortcut-btn" 
              on:click={() => selectGroup(group)}
              type="button"
            >
              {group.name}
            </button>
          {/each}
        </div>
      {/if}
    </div>
  {/if}

  {#each allContacts as contact}
    <ContactSelectionItem
      contact={contact.contact}
      bind:selected={contact.selected}
      on:errorMessage={setErrorMessage}
    />
  {/each}
</div>

<footer>
  <slot name="footer"></slot>

  <button class="send -button-primary" disabled={disabled || selection.length === 0} on:click={confirm}>
    {#if selection.length === 0}
      Select at least one friend
    {:else}
      Send to {selection.length} friend{selection.length === 1 ? '' : 's'}

      <svg class="feather-icon">
        <use href="feather-sprite.svg#send" />
      </svg>
    {/if}
  </button>
</footer>

<style>
  .list {
    margin: 0.8rem 1rem 1.5rem 1rem;
  }

  .selection-header {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.75rem;
    border-bottom: 1px solid var(--light-gray);
    margin-bottom: 0.5rem;
    padding-bottom: 0.25rem;
  }

  .select-all {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem 0;
    margin-bottom: 0;
  }

  .friend-groups-shortcuts {
    display: flex;
    flex-wrap: wrap;
    gap: 0.35rem;
    align-items: center;
  }

  .group-shortcut-btn {
    font-size: 0.8rem;
    padding: 0.25rem 0.6rem;
    border: 1px solid var(--brand-color);
    border-radius: 1rem;
    color: var(--brand-color);
    background-color: transparent;
    cursor: pointer;
    transition: background-color 0.2s, color 0.2s;
  }

  .group-shortcut-btn:hover {
    background-color: var(--brand-color);
    color: var(--white);
  }

  footer {
    text-align: right;
    padding: 0.5rem 1rem;
    display: flex;
    justify-content: space-between;
    align-items: end;
    position: sticky;
    bottom: 0;
    background-color: var(--white);
  }

  button.send > .feather-icon {
    margin-left: 0.3em;
    transform: rotate(45deg);
  }
</style>
